import {ResourceType} from "../../definitions/types";
import {currencyFormatter} from "../../utils/helpers";

export class WarrantyModel {
    private readonly _warranty: ResourceType;

    constructor(public readonly warranty: ResourceType) {
        this._warranty = warranty;
    }

    /**
     * @method id
     * @description Returns the id of the warranty (e.g., 1, 2, 3, etc.)
     * @returns {number}
     */
    public get id(): number {
        return this._warranty.id;
    }

    /**
     * @method name
     * @description Returns the name of the warranty (e.g. "1 Year", "2 Years", etc.)
     * @returns {string}
     */
    public get name(): string {
        return this._warranty.name;
    }

    /**
     * @method price
     * @description Returns the price of the warranty
     * @returns {number}
     */
    public get price(): number {
        return this._warranty.price;
    }

    /**
     * @method title
     * @description Returns the title of the warranty
     * @returns {string}
     */
    public get title(): string {
        return this._warranty.title;
    }

    /**
     * @method type
     * @description Returns the type of the warranty
     * @returns {number}
     */
    public get type(): number {
        return this._warranty.type;
    }

    /**
     * @property isFurniture
     * @description Returns true if the warranty is for furniture (type 1)
     * @returns {boolean}
     */
    public get isFurniture(): boolean {
        return this.type === 1;
    }

    /**
     * @property isDigital
     * @description Returns true if the warranty is for digital (type 2)
     * @returns {boolean}
     */
    public get isDigital(): boolean {
        return this.type === 2;
    }

    /**
     * @method formatted
     * @description Returns the fields of the model formatted for display
     * @returns {{price: string}}
     */
    public get formatted(): { price: string } {
        return {
            price: currencyFormatter.format(this.price)
        }
    }
}